import { Component, createRef } from 'react';
import {
  Popover,
  Grid,
  Button,
  withStyles,
  Typography,
  CircularProgress
} from '@material-ui/core';
import {
  CallRounded as JoinIcon,
  AssignmentRounded as DetailsIcon
} from '@mui/icons-material';
import { DateTime } from 'luxon';
import { getErrorMessage } from 'helpers';
import { withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';
import {
  Portlet,
  PortletHeader,
  PortletLabelAvatar,
  PortletContent
} from 'components';
import BookingInfo from 'components/BookingInfo';
import compose from 'recompose/compose';
import styles from './styles';
import firebase from 'firebase/app';

class JoinCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentBooking: null,
      bookings: [],
      groupSessions: [],
      callJoining: false,
      callToken: null,
      callWindowHandle: null,
      popoverAnchor: null,
      initialToken: null,
      checkBeforeunload: false
    };
    this.cancelConfirmDialog = createRef();

    this.refresh = this.refresh.bind(this);
    this.onUnload = this.onUnload.bind(this);
    this.onSnapData = this.onSnapData.bind(this);
    this.onSnapDataGroupSessions = this.onSnapDataGroupSessions.bind(this);
    this.onSnapError = this.onSnapError.bind(this);
    this.joinBooking = this.joinBooking.bind(this);
    this.gotoBookings = this.gotoBookings.bind(this);
    this.retryHook = this.retryHook.bind(this);
    this.checkBookingStatus = this.checkBookingStatus.bind(this);
    this.handleStorageChange = this.handleStorageChange.bind(this);
    this.setupStatusListener = this.setupStatusListener.bind(this);

    this.ready = true;
    this.onBeforeUnloadFired = false;
    this.statusListener = null;
  }

  async componentDidMount() {
    const { auth } = this.props;

    this.bookingsHook = auth.api.bookings.hook(
      'bookingsMyLiveBookings',
      this.onSnapData,
      this.onSnapError,
      'JoinCard'
    );
    this.groupSessionsHook = auth.api.groupSessions.hook(
      'groupsessionsMyLiveBookings',
      this.onSnapDataGroupSessions,
      this.onSnapError,
      'UpcomingBookingsView'
    );

    this.refreshInterval = setInterval(this.refresh, 1000);
    this.statusCheckInterval = setInterval(this.checkBookingStatus, 30000); // Check every 30 seconds

    window.addEventListener('storage', this.handleStorageChange);
    window.addEventListener('beforeunload', this.onUnload);
    window.addEventListener('pagehide', this.onUnload);
  }

  componentWillUnmount() {
    if (this.bookingsHook) this.bookingsHook();
    if (this.groupSessionsHook) this.groupSessionsHook();
    if (this.refreshInterval) clearInterval(this.refreshInterval);
    if (this.statusCheckInterval) clearInterval(this.statusCheckInterval);
    if (this.statusListener) this.statusListener();

    this.ready = false;
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('beforeunload', this.onUnload);
    window.removeEventListener('pagehide', this.onUnload);
  }

  handleStorageChange(event) {
    if (event.key === 'booking_status_update') {
      try {
        const data = JSON.parse(event.newValue);
        const { currentBooking } = this.state;

        if (currentBooking && data.id === currentBooking.id) {
          this.setState({
            currentBooking: {
              ...currentBooking,
              status: data.status
            }
          });
        }
      } catch (error) {
        console.error('Error handling storage event:', error);
      }
    }
  }

  async checkBookingStatus() {
    const { currentBooking } = this.state;
    if (!currentBooking) return;

    this.setupStatusListener(currentBooking);
  }

  setupStatusListener(booking) {
    if (this.statusListener) {
      this.statusListener();
      this.statusListener = null;
    }

    try {
      this.statusListener = firebase
        .firestore()
        .collection('tutors')
        .doc(booking.tutor)
        .collection('bookings')
        .doc(booking.id)
        .onSnapshot(
          (doc) => {
            if (doc.exists) {
              const bookingData = doc.data();
              if (bookingData && bookingData.status !== booking.status) {
                this.setState({
                  currentBooking: {
                    ...booking,
                    status: bookingData.status
                  }
                });

                localStorage.setItem(
                  'booking_status_update',
                  JSON.stringify({
                    id: booking.id,
                    status: bookingData.status,
                    timestamp: Date.now()
                  })
                );
              }
            }
          },
          (error) => console.error('Error in booking listener:', error)
        );
    } catch (error) {
      console.error('Error setting up status listener:', error);
    }
  }

  onUnload() {
    const { callWindowHandle } = this.state;
    if (callWindowHandle) callWindowHandle.close();
  }

  onSnapData(snap) {
    if (this.ready) {
      const updatedBookings = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      this.setState({
        bookings: updatedBookings
      });
    }
  }

  onSnapDataGroupSessions(snap) {
    const { auth } = this.props;
    if (this.ready) {
      const currentUserId = auth.user.uid;
      const bookingsArray = [];
      // current time + 10 minutes
      console.log('currentTime', Date.now() + 10 * 60 * 1000);
      snap.docs.forEach((doc) => {
        const id = doc.id;
        const sessionData = {
          id,
          ...doc.data()
        };

        if (sessionData.bookings) {
          sessionData.bookings
            .filter((booking) => {
              const isStudent =
                booking.studentIds &&
                booking.studentIds.includes(currentUserId);
              const isTutor =
                booking.tutor && booking.tutor.uid === currentUserId;

              const isUpcoming =
                booking.status === 'booked' ||
                booking.status === 'in-progress' ||
                booking.status === 'open' ||
                booking.status === 'tutor-absent';

              return (isStudent || isTutor) && isUpcoming;
            })
            .forEach((filteredBooking) => {
              bookingsArray.push({
                ...sessionData,
                bookingId: filteredBooking.bookingId,
                when: filteredBooking.when,
                bookings: [filteredBooking],
                status: filteredBooking.status,
                profile: {
                  ...filteredBooking.profile,
                  student:
                    filteredBooking?.students?.length &&
                    filteredBooking.students[0],
                  tutor: filteredBooking.tutor
                },
                studentCount: filteredBooking.students?.length - 1
              });
            });
        }
      });

      this.setState({
        groupSessions: bookingsArray.sort((a, b) => a.when - b.when)
      });
    }
  }

  onSnapError(error) {
    const { enqueueSnackbar } = this.props;
    enqueueSnackbar(`${getErrorMessage(error)} (try reloading the page)`, {
      variant: 'error'
    });
    console.error(error);
  }

  gotoBookings() {
    const { history, auth } = this.props;
    history.push(`/${auth.role}/bookings`);
  }

  refresh() {
    const { bookings, groupSessions } = this.state;

    const findValidBooking = (items) => {
      for (const item of items) {
        const timeDiff = Date.now() - item.when;

        if (
          timeDiff >= -600000 &&
          timeDiff <= 3000000 &&
          ![
            'completed',
            'pending',
            'student-cancelled',
            'tutor-cancelled'
          ].includes(item.status)
        ) {
          return item;
        }
      }
      return null;
    };

    const validBooking = findValidBooking(bookings);

    if (validBooking) {
      this.setState({ currentBooking: validBooking });
      return;
    }
    const validGroupSession = findValidBooking(groupSessions);
    if (validGroupSession) {
      validGroupSession.type = 'group';
      this.setState({ currentBooking: validGroupSession });
      return;
    }

    this.setState({ currentBooking: null, callToken: null });
  }

  retryHook() {
    this.setState({
      currentBooking: null
    });

    if (this.bookingsHook) this.bookingsHook();

    this.componentDidMount();
  }

  async joinBooking(callWindowHandle) {
    const { auth, enqueueSnackbar } = this.props;
    const { currentBooking, callToken } = this.state;

    try {
      const token =
        callToken ||
        (currentBooking?.type === 'group'
          ? await auth.api.groupSessions.joinGroupSession(
              currentBooking.id,
              currentBooking.bookingId
            )
          : await auth.api.bookings.joinBooking(
              currentBooking.id,
              currentBooking.tutor
            )
        ).token;

      let redirection = `/call?token=${token}&room=${currentBooking.tutor}-${currentBooking.id}`;

      if (currentBooking.type === 'group') {
        redirection = `/call?token=${token}&room=${currentBooking.tutor}-${currentBooking.bookingId}&group=true`;
      }

      callWindowHandle.location = redirection;

      let refreshIntervalId = setInterval(() => {
        if (callWindowHandle.closed) {
          this.setState({
            callToken: token,
            callJoining: false,
            callWindowHandle
          });

          this.setState({
            callWindowHandle: null
          });

          clearInterval(refreshIntervalId);
        }
      }, 1000);
    } catch (error) {
      console.error(error);
      this.setState({
        callJoining: false
      });

      enqueueSnackbar(getErrorMessage(error), { variant: 'error' });
    }
  }

  render() {
    const { classes, auth } = this.props;

    const { currentBooking, callJoining, callWindowHandle, popoverAnchor } =
      this.state;
    const roleSwitch = {
      student: 'tutor',
      tutor: 'student'
    }[auth.role];

    if (!currentBooking) return null;

    return (
      <>
        <Popover
          id={popoverAnchor ? 'simple-popover' : undefined}
          open={Boolean(popoverAnchor)}
          anchorEl={popoverAnchor}
          onClose={() => {
            this.setState({ popoverAnchor: null });
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}>
          <BookingInfo
            info={currentBooking.info ?? currentBooking?.bookings[0].info}
            booking={{
              ...currentBooking,
              info: currentBooking.info ?? currentBooking?.bookings[0].info
            }}
          />
        </Popover>

        <div className={classes.root}>
          <Portlet className={classes.portlet}>
            <PortletHeader>
              {currentBooking.profile[roleSwitch] && (
                <PortletLabelAvatar
                  avatar={currentBooking.profile[roleSwitch].image}
                  name={currentBooking.profile[roleSwitch].name}
                  title={
                    currentBooking?.type && auth.role === 'tutor'
                      ? `Group Session Booking with ${currentBooking.profile[roleSwitch].name} and ${currentBooking?.studentCount} others`
                      : `Booking with ${currentBooking.profile[roleSwitch].name}`
                  }
                  subtitle={DateTime.fromMillis(
                    currentBooking.when
                  ).toRelative()}
                />
              )}
            </PortletHeader>
            <PortletContent>
              <Grid container spacing={1} justifyContent="center">
                <Grid item>
                  <div className={classes.waiting}>
                    <Button
                      className={classes.bookingsBtn}
                      variant="outlined"
                      onClick={(ev) => {
                        this.setState({ popoverAnchor: ev.target });
                      }}
                      color="primary"
                      startIcon={<DetailsIcon />}>
                      view details
                    </Button>
                    {(() => {
                      if (auth.role === 'student') {
                        if (currentBooking.status === 'in-progress') {
                          return (
                            <Button
                              disabled={
                                Boolean(callWindowHandle) || callJoining
                              }
                              variant="contained"
                              onClick={() => {
                                const { enqueueSnackbar } = this.props;
                                const { currentBooking } = this.state;

                                if (!currentBooking) {
                                  enqueueSnackbar(
                                    'Cannot commence an empty booking!',
                                    {
                                      variant: 'error'
                                    }
                                  );
                                  return;
                                }
                                this.setState({ callJoining: true });
                                const bookingId =
                                  currentBooking.type === 'group'
                                    ? currentBooking.bookingId
                                    : currentBooking.id;

                                localStorage.setItem(
                                  `call-${bookingId}`,
                                  JSON.stringify({
                                    ...currentBooking,
                                    id: currentBooking.bookingId
                                  })
                                );

                                const callWindowHandle = window.open(
                                  '',
                                  '_blank',
                                  'location'
                                );
                                this.joinBooking(callWindowHandle);
                              }}
                              color="primary"
                              startIcon={<JoinIcon />}>
                              {callJoining && (
                                <CircularProgress
                                  className={classes.callLoader}
                                  size={24}
                                />
                              )}
                              join lesson
                            </Button>
                          );
                        } else if (currentBooking.status === 'tutor-absent') {
                          return (
                            <Typography
                              className={classes.waitingText}
                              variant="subtitle1">
                              Sorry, it looks like we can&apos;t get a hold of
                              your tutor. Your lesson token has been refunded.
                            </Typography>
                          );
                        } else {
                          return (
                            <>
                              <div className={classes.waitingLoader}>
                                <CircularProgress size={30} />
                              </div>
                              <Typography
                                className={classes.waitingText}
                                variant="subtitle1">
                                Waiting for your tutor to commence the lesson
                              </Typography>
                            </>
                          );
                        }
                      } else if (auth.role === 'tutor') {
                        if (
                          currentBooking.status === 'booked' ||
                          currentBooking.status === 'open'
                        ) {
                          if (Date.now() > currentBooking.when + 300000) {
                            return (
                              <Typography
                                className={classes.waitingText}
                                variant="subtitle1">
                                Commencement deadline missed, student has been
                                refunded.
                              </Typography>
                            );
                          }

                          return (
                            <>
                              <Button
                                disabled={
                                  Boolean(callWindowHandle) || callJoining
                                }
                                className={classes.bookingsBtn}
                                variant="contained"
                                onClick={() => {
                                  const { enqueueSnackbar } = this.props;
                                  const { currentBooking } = this.state;

                                  if (!currentBooking) {
                                    enqueueSnackbar(
                                      'Cannot commence an empty booking!',
                                      {
                                        variant: 'error'
                                      }
                                    );
                                    return;
                                  }
                                  this.setState({ callJoining: true });

                                  const bookingId =
                                    currentBooking.type === 'group'
                                      ? currentBooking.bookingId
                                      : currentBooking.id;

                                  localStorage.setItem(
                                    `call-${bookingId}`,
                                    JSON.stringify({
                                      ...currentBooking,
                                      id: currentBooking.bookingId
                                    })
                                  );

                                  const callWindowHandle = window.open(
                                    '',
                                    '_blank',
                                    'location'
                                  );
                                  this.joinBooking(callWindowHandle);
                                }}
                                color="primary"
                                startIcon={<JoinIcon />}>
                                {callJoining && (
                                  <CircularProgress
                                    className={classes.callLoader}
                                    size={24}
                                  />
                                )}
                                Commence Lesson
                              </Button>
                            </>
                          );
                        } else if (currentBooking.status === 'in-progress') {
                          return (
                            <>
                              <Button
                                disabled={
                                  Boolean(callWindowHandle) || callJoining
                                }
                                className={classes.bookingsBtn}
                                variant="contained"
                                onClick={() => {
                                  const { enqueueSnackbar } = this.props;
                                  const { currentBooking } = this.state;

                                  if (!currentBooking) {
                                    enqueueSnackbar(
                                      'Cannot commence an empty booking!',
                                      {
                                        variant: 'error'
                                      }
                                    );
                                    return;
                                  }
                                  this.setState({ callJoining: true });

                                  const bookingId =
                                    currentBooking.type === 'group'
                                      ? currentBooking.bookingId
                                      : currentBooking.id;

                                  localStorage.setItem(
                                    `call-${bookingId}`,
                                    JSON.stringify({
                                      ...currentBooking,
                                      id: currentBooking.bookingId
                                    })
                                  );

                                  const callWindowHandle = window.open(
                                    '',
                                    '_blank',
                                    'location'
                                  );
                                  this.joinBooking(callWindowHandle);
                                }}
                                color="primary"
                                startIcon={<JoinIcon />}>
                                {callJoining && (
                                  <CircularProgress
                                    className={classes.callLoader}
                                    size={24}
                                  />
                                )}
                                Join Lesson
                              </Button>
                            </>
                          );
                        } else if (currentBooking.status === 'tutor-absent') {
                          return (
                            <>
                              <Typography
                                className={classes.waitingText}
                                variant="subtitle1">
                                Commencement deadline missed, student has been
                                refunded.
                              </Typography>
                            </>
                          );
                        }
                      }
                    })()}
                  </div>
                </Grid>
              </Grid>
            </PortletContent>
          </Portlet>
        </div>
      </>
    );
  }
}

export default compose(withRouter, withSnackbar, withStyles(styles))(JoinCard);
